import * as React from "react";
import CandidateInformationList from "../candidate/CandidateInformationList";
import TranslatedMessage from "../translations/TranslatedMessage";
import { Button, Grid, Typography } from "@material-ui/core";
import { Cake, Edit, PhoneIphone } from "@material-ui/icons";
import { getMinimumValidDate } from "../../utils/Dates";
import { PersonType } from "../../model/PersonType";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { routesPaths } from "../../Routes";
import { CandidateViewModel } from "../../model/CandidateViewModel";
import { SwissGermanLocale, SwissTimeZone } from '../../data/constants';

type UserReadOnlyViewProps = {
  user: CandidateViewModel;
} & RouteComponentProps;

class UserReadOnlyView extends React.PureComponent<UserReadOnlyViewProps> {
  public render(): JSX.Element {
    const { user } = this.props;
    const infoList = [{ icon: PhoneIphone, data: [user.mobileNumber, user.phoneNumber] }];

    const showUserBirthdate =
      user.birthdate && user.birthdate != null && new Date(user.birthdate) > getMinimumValidDate();

    if (showUserBirthdate) {
      infoList.push({ icon: Cake, data: [new Date(user.birthdate).toLocaleDateString(SwissGermanLocale, { timeZone: SwissTimeZone })] });
    }

    return (
      <Grid container={true}>
        <Grid item={true} xs={8}>
          <Typography>
            {user.firstName} {user.lastName}
          </Typography>
          {user.emailAddress && <Typography>{user.emailAddress}</Typography>}
        </Grid>
        <Grid item={true} xs={4}>
          <CandidateInformationList items={infoList} />
        </Grid>
        {user &&
          (user.type === PersonType.Candidate || user.type === PersonType.Expert) &&
          this.renderEditProfileButton(user.type)}
      </Grid>
    );
  }

  private renderEditProfileButton = (type: PersonType) => (
    <Grid item={true}>
      <Button variant="contained" size="small" color="primary" onClick={() => this.handleProfileClick(type)}>
        <Edit />
        <TranslatedMessage id="home.me.edit" />
      </Button>
    </Grid>
  );

  private handleProfileClick = (type: PersonType) => {
    switch (type) {
      case PersonType.Candidate:
        this.props.history.push(routesPaths.userProfile());
        break;
      case PersonType.Expert:
        this.props.history.push(routesPaths.expertProfile());
        break;
    }
  };
}

export default withRouter(UserReadOnlyView);
